import LibraryMeter from '../../../components/library/LibraryMeter';

type WarehouseMeterProps = {
  done: number;
  total: number;
  /** Words after "9 of 14", e.g. "picked" or "in". */
  suffix?: string;
};

/** "9 of 14 picked" with a small bar; the text carries the meaning, the bar is decoration. */
export default function WarehouseMeter({ done, total, suffix }: WarehouseMeterProps) {
  return <LibraryMeter done={done} total={total} suffix={suffix} classPrefix="warehouse-meter" />;
}
